export default __webpack_public_path__ + "static/media/KerkyraMap.95b67f17.jpg";